import React from 'react';

import { getMenuIcons } from '../../../redux/data/menu';
import { VpHoverInfo } from '../VpHoverInfo';
import { VpIcon } from '../';
import { StyledVpLink } from './styles';

export const MenuIcons = ({ ...rest }) => {
  return (
    <>
      {getMenuIcons()?.map((item) => (
        <StyledVpLink
          to={item?.url.includes('http') ? { pathname: item?.url } : item?.url}
          target={item?.url.includes('http') ? '_blank' : ''}
          key={item?.id}
          {...rest}
        >
          <VpHoverInfo label={item?.text}>
            <VpIcon icon={item?.icon} />
          </VpHoverInfo>
        </StyledVpLink>
      ))}
    </>
  );
};

export default MenuIcons;



// WEBPACK FOOTER //
// ./src/vp-ui/components/NavMenuIcons/MenuIcons.jsx